module.exports = __webpack_public_path__ + "assets/img/s2-subtitle-2-df2b83b8.png";